import React, { PureComponent, PropTypes } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import Modal from 'react-modal';

import zip from 'lodash/zip';

import { closeCart, removeRow } from '../../redux/actions';
import { selectHydrated } from '../../redux/modules/cart/selectors';
import ProductTable from '../../components/ProductTable';

import './Cart.scss';

const customStyles = {
  content: {
    minWidth              : '1100px',
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    border                : 0
  },
  overlay: {
    zIndex: 1031,
    background: 'rgba(0, 0, 0, 0.3)'
  }
};

class Cart extends PureComponent {
  static proptTypes = {
    rows: PropTypes.array.isRequired,
    result: PropTypes.object.isRequired,
    closeCart: PropTypes.func.isRequired,
    removeRow: PropTypes.func.isRequired,
  };

  checkout = () => {
    // close and redirect
    this.props.closeCart();
    this.props.history.push('/checkout');
  }

  render() {
    const { rows, result, closeCart, removeRow } = this.props;
    return (
      <div className="modal-content" id="cart-modal">
        <h1 className="modal-title">Grozs</h1>
        <p>
          Apstiprinājumu par kampaņas izvietojumu saņemsiet pēc pasūtījuma noformējuma.
        </p>
        <div className="row-container-wrap">
          <ProductTable rows={rows} removeRow={removeRow} />
          <div className="row">
            <div className="col-12">
              <table className="totals pull-right">
                <tbody>
                  <tr>
                    <td>Summa bez PVN</td>
                    <td>{result.totalWoVat}</td>
                  </tr>
                  <tr>
                    <td>PVN {result.vatRate}%</td>
                    <td>{result.totalVat}</td>
                  </tr>
                  <tr className="final">
                    <td>Kopā</td>
                    <td>{result.totalWVat}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={closeCart}
              >
                Turpināt iepirkties
              </button> 
              <button
                onClick={this.checkout}
                className="btn btn-primary float-right"
                disabled={rows.length === 0}
              >
                <i className="fa fa-check-circle"/> Noformēt pasūtījumu
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
};

const WrappedCart = withRouter(Cart);

class CartModal extends PureComponent {
  static proptTypes = {
    open: PropTypes.bool.isRequired,
    rows: PropTypes.array.isRequired,
    result: PropTypes.object.isRequired,
    closeCart: PropTypes.func.isRequired,
    removeRow: PropTypes.func.isRequired,
  }

  render() {
    const { open, ...rest} = this.props;
    return (
      <Modal
        isOpen={open}
        style={customStyles}
        contentLabel="Grozs"
        onRequestClose={this.props.closeCart}
      >
        <WrappedCart {...rest}/>
      </Modal>
    )
  }
};

const mapStateToProps = (state, props) => {
  const cart = selectHydrated(state);
  return {
    open: state.cart.open,
    rows: cart ? zip(cart.items, cart.result.items) : [],
    result: cart? cart.result : null,
  }
};


export default connect(
  mapStateToProps,
  {
    closeCart,
    removeRow,
})(CartModal);



// WEBPACK FOOTER //
// ./src/containers/Cart/index.js